import React, { useState, useMemo } from "react";
import { Tag } from "..";
import { useCurrentPost, usePostTags } from "../../hooks";
import TagSelect from "../file-tag-select";

export default function EditTags({
  tags = null,
  deleteTag = null,
  showDelete = true,
  showAdd = false,
  addTag = null,
}) {
  const [tagSelect, setTagSelect] = useState(null);
  const { deleteTagFromPost: genericDelete } = usePostTags({
    initialize: false,
  });

  const { currentPost } = useCurrentPost({ initialize: false });

  const createTagSelect = () => {
    setTagSelect(
      <TagSelect
        sendUpdates={false}
        onUpdate={async (e) => {
          await addTag(e);
          setTagSelect(null);
        }}
        currentTags={tags || currentPost.tags}
      />
    );
  };

  const tagList = useMemo(() => {
    const tagsToUse = tags || currentPost.tags;
    if (!tagsToUse) {
      return null;
    }
    return tagsToUse.map((tag) => (
      <Tag
        key={typeof tag === "string" ? tag : (tag || {}).name}
        tagName={tag}
        showDelete={showDelete}
        deleteTag={deleteTag ? deleteTag : genericDelete}
      />
    ));
  }, [currentPost, genericDelete, showDelete, deleteTag, tags]);

  return (tagList && tagList.length > 0) || showAdd ? (
    <p className="post-tags">
      {tagList}
      {showAdd && (
        <Tag tagName="+" showDelete={false} onClick={createTagSelect} />
      )}
      {tagSelect ? (
        <>
          <br />
          {tagSelect}
        </>
      ) : null}
    </p>
  ) : null;
}
